module.exports = __WEBPACK_EXTERNAL_MODULE_pdfjs_dist_d4c2aa0a__;